import axiosWrapper, { InterceptorOptions } from './axios-wrapper'

const api = axiosWrapper.create(
  {
    baseURL: '/tracer',
    responseType: 'json',
    headers: {
      'Content-Type': 'application/json',
    },
  },
  InterceptorOptions.defaultErrorInterceptor,
)

export function apiGetMakeModels() {
  return api.get(`/make-models`).then((resp) => resp.data)
}

export function apiGetMakeModelsByPlant({ plantName }) {
  const params = new URLSearchParams()
  params.set('plantName', plantName)

  return api.get(`/make-models?${params.toString()}`).then((resp) => resp.data)
}

export function apiGetMakeModelByVin({ vin }) {
  return api.get(`/make-model-by-vin/${vin}`).then((resp) => resp.data)
}
